import { render, staticRenderFns } from "./CSSellRecords.vue?vue&type=template&id=fa256d02&lang=pug&"
import script from "./CSSellRecords.vue?vue&type=script&lang=js&"
export * from "./CSSellRecords.vue?vue&type=script&lang=js&"
import style0 from "./CSSellRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports